import { CCol, CRow } from '@coreui/react-pro';
import React from 'react';
import { CART_TYPES, REGEX_EMBED, REGEX_WISTIA, REGEX_YOUTUBE } from '../../../../../constants';
import { getFileData } from '../../../../../utils';
import { Media } from '../../../../General/Media';
import TrainingCourse from '../TrainingSeatDetails/TrainingCourse';

const OnlineCourses = ({ product, relatedProduct }) => {
     const headline =
          (product.relatedProductProductId ? product.relatedPageOrgHeadline : product.pageOrgHeadline) ||
          product.headLineOrg ||
          product.relatedProductSubject ||
          product.publishName;

     const subHeadline = product.relatedProductProductId ? product.relatedPageOrgSubHeadline : product.pageOrgSubHeadline;

     const bodyText =
          (product.relatedProductProductId ? product.relatedPageOrgBodyText : product.pageOrgBodyText) ||
          (product.descriptionOrg ? product.descriptionOrg : product.relatedProductDescription);

     const image = product.relatedProductProductId ? product.relatedPageOrgImage : product.pageOrgImage;

     const isVideo = () => {
          const fileData = getFileData(image);

          const isEmbed = REGEX_EMBED.test(image);
          const isVideoYoutube = REGEX_YOUTUBE.test(image);
          const isVideoWistia = REGEX_WISTIA.test(image);

          if (isEmbed || isVideoYoutube || isVideoWistia || fileData.extension === 'mp4') {
               return true;
          }
          return false;
     };

     return (
          product && (
               <div className="online-course-detail" key={product.id}>
                    <div className="detail-course-org">
                         <div className={`header-course-org ${!isVideo() ? 'd-flex' : ''}`}>
                              <div className="content-course-org">
                                   <h3>{headline}</h3>

                                   <div className="training-intro-short-description">
                                        <p className="purchase" dangerouslySetInnerHTML={{ __html: subHeadline }} />
                                   </div>

                                   <div className="training-intro-description">
                                        <p className="text-editor" dangerouslySetInnerHTML={{ __html: bodyText }} />
                                   </div>
                              </div>

                              {image && !isVideo() && (
                                   <div className="image-course-org">
                                        <img src={image} alt=""></img>
                                   </div>
                              )}

                              {image && isVideo() && <Media src={image} />}
                         </div>

                         <CRow>
                              <CCol>
                                   {[CART_TYPES.ORGANIZATION, CART_TYPES.BOTH].includes(product.purchaseType) && <TrainingCourse product={product} />}

                                   {relatedProduct && [CART_TYPES.ORGANIZATION, CART_TYPES.BOTH].includes(relatedProduct.purchaseType) && (
                                        <TrainingCourse product={relatedProduct} />
                                   )}
                              </CCol>
                         </CRow>
                    </div>
               </div>
          )
     );
};

export default OnlineCourses;
